"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.convertToOptions = exports.COMPONENT_NAME = exports.BG_COLOR = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.modal-atencion-emp"));
var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");
var _contactBarUtils = require("./contactBarUtils");
require("./index.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const COMPONENT_NAME = 'ContactBar';
exports.COMPONENT_NAME = COMPONENT_NAME;
const convertToOptions = optionsObject => {
  const keys = Object.keys(optionsObject);
  return keys.map(key => {
    return optionsObject[key];
  });
};
exports.convertToOptions = convertToOptions;
const BG_COLOR = {
  NAVY_DARK: 'navy-dark',
  BLACK: 'black',
  WHITE: 'white',
  GREEN: 'green',
  GREEN_LIGHT: 'green-light',
  GREEN_DARK: 'green-dark',
  COOL_GREY: 'cool-grey',
  GREY_6: 'grey6',
  GREY_5: 'grey5',
  GREY_5B: 'grey5b',
  GREY_4: 'grey4',
  GREY_4A: 'grey4a',
  GREY_3: 'grey3',
  GREY_2: 'grey2',
  GREY_1: 'grey1',
  GREY_1A: 'grey1a',
  GREY_A: 'greya',
  GREY_0: 'grey0',
  ORANGE: 'orange',
  ORANGE_LIGHT: 'orange-light',
  ORANGE_DARK: 'orange-dark',
  EGG: 'egg',
  BLUE: 'blue',
  BLUE_A: 'blue-a',
  BLUE_DARK: 'dark-blue',
  PURPLE: 'purple',
  PURPLE_LIGHT: 'purple-light',
  PURPLE_DARK: 'purple-dark',
  PINK: 'pink',
  PINK_LIGHT: 'pink-light',
  PINK_DARK: 'pink-dark',
  PIPPER: 'pipper',
  PIPPER_LIGHT: 'pipper-light',
  PIPPER_DARK: 'pipper-dark',
  CORAL: 'coral',
  DARK_GREEN: 'dark-green',
  MEDIUM_GREEN: 'medium-green',
  LIGHT_GREEN: 'light-green',
  DARK_ORANGE: 'dark-orange',
  MEDIUM_ORANGE: 'medium-orange',
  LIGHT_ORANGE: 'light-orange',
  LIGHT_BLUE: 'light-blue',
  MEDIUM_BLUE: 'medium-blue',
  DARK_BLUE: 'dark-blue',
  DARK_PURPLE: 'dark-purple',
  MEDIUM_PURPLE: 'medium-purple',
  LIGHT_PURPLE: 'light-purple',
  RED: 'red',
  DARK_YELLOW: 'dark-yellow',
  MEDIUM_YELLOW: 'medium-yellow',
  LIGHT_YELLOW: 'light-yellow',
  ORCHID_DARK: 'orchid-dark'
};
exports.BG_COLOR = BG_COLOR;
class ContactBar extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      if (this.props.fixedBar) {
        window.addEventListener('scroll', this.onScroll);
      }
      if (this.props.bgImage) (0, _contactBarUtils.generateBgContactBar)(this.state.newId, this.props.bgImage);
    });
    _defineProperty(this, "componentWillUnmount", () => {
      window.removeEventListener('scroll', this.onScroll);
    });
    _defineProperty(this, "onScroll", () => {
      if (window.document.getElementById('ContactBar-wrapper') && window.document.getElementById('ContactBar-wrapper').getBoundingClientRect().top <= 0) {
        const contactBarElement = window.document.getElementById('ContactBar-wrapper');
        const contactBarElementHeight = contactBarElement.offsetHeight;
        if (!this.state.fixed) {
          this.setState({
            fixed: true
          }, () => {
            window.document.getElementById('ContactBar-wrapper').style.height = `${contactBarElementHeight}px`;
          });
        }
      } else {
        if (this.state.fixed) {
          this.setState({
            fixed: false
          });
        }
      }
    });
    const newId = `ContactBar${(0, _gerenciatdUtils.giveRandomNumber)(0, 1000)}`;
    this.state = {
      fixed: false,
      newId
    };
  }
  render() {
    const {
      fixed,
      newId
    } = this.state;
    const {
      segment,
      bgImage,
      components,
      visible,
      bgColor,
      Modal,
      newUrl,
      SvgIconLoader,
      tabsOptions,
      product
    } = this.props;
    let {
      taggingInfo
    } = this.props;
    if (newUrl && components['Button-1'] && components['Button-1'].link) {
      components['Button-1'].link = newUrl;
    }
    if (!taggingInfo) {
      taggingInfo = {
        componentVariation: 'all',
        componentName: COMPONENT_NAME,
        componentProduct: product || ''
      };
    }
    const onClick = item => {
      Modal.setModalProps({
        contentPosition: 'right--center',
        opacityLayoutColor: 'black05',
        inSceneEffect: 'faseInLeft',
        outSceneEffect: 'fadeOutRight',
        closeByClickingOutside: true,
        scrollAllowed: false
      });
      Modal.setContent( /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
        Modal: Modal,
        SvgIconLoader: SvgIconLoader,
        tabsOptions: _objectSpread(_objectSpread({}, tabsOptions), {}, {
          tabOptionPreChecked: item.option
        }),
        product: item.product,
        taggingInfo: taggingInfo,
        campaign: item.campaign
      }));
      Modal.show();
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: "ContactBar-wrapper",
      children: visible && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `ContactBar ${fixed ? 'ContactBar--fixed' : ''} ${bgImage ? '' : `ContactBar_bgColor--${segment}-${bgColor}`}`,
        id: newId,
        children: [components['Button-llamada'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({
          className: "ContactBar__item",
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: components['Button-llamada'].label,
            componentVariation: components['Button-llamada'].campaign || taggingInfo.componentVariation
          })
        }, components['Button-llamada']), {}, {
          onClick: () => {
            onClick(components['Button-llamada']);
          }
        })), components['Button-solicita'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({
          className: "ContactBar__item",
          taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
            componentContent: components['Button-solicita'].label,
            componentVariation: components['Button-solicita'].campaign || taggingInfo.componentVariation
          })
        }, components['Button-solicita']), {}, {
          onClick: () => {
            onClick(components['Button-solicita']);
          }
        }))]
      })
    });
  }
}
ContactBar.propTypes = {
  visible: _propTypes.default.bool,
  bgColor: _propTypes.default.oneOf(convertToOptions(BG_COLOR)),
  bgImage: _propTypes.default.string,
  segment: _propTypes.default.string.isRequired
};
ContactBar.defaultProps = {
  visible: true,
  bgColor: BG_COLOR.NAVY_DARK,
  bgImage: '',
  segment: 'emp'
};
var _default = ContactBar;
exports.default = _default;

//# sourceMappingURL=index.js.map